import {
  asyncSuccess,
  asyncFailure,
  getRESTHeader,
  objectToQueryParams,
} from "utils"

export const readAgencyRequests = ({ query, ...options }) => {
  const requestOptions = {
    method: "GET",
    headers: getRESTHeader(),
    ...options,
  }

  return fetch(
    `${BASE_URL}/call-center${objectToQueryParams(query)}`,
    requestOptions,
  ).then(asyncSuccess, asyncFailure)
}

export const updateAgencyRequest = ({ data, ...options }) => {
  const requestOptions = {
    method: "PUT",
    headers: getRESTHeader(),
    body: JSON.stringify(data),
    ...options,
  }

  return fetch(`${BASE_URL}/call-center`, requestOptions).then(
    asyncSuccess,
    asyncFailure,
  )
}